<template>
  <div class="content">
    <div class="content-box">
      <div class="top">
        <div style="display: flex; align-items: center; width: 60%">
          <el-input
            size="small"
            placeholder="请输入抓拍机序列号"
            v-model="serialNum"
            clearable
          ></el-input>
          <span class="button" @click="select">查询</span>
        </div>
        <span class="button" @click="add">绑定</span>
      </div>

      <div class="table">
        <el-table :data="tableData" height="100%" border>
          <el-table-column label="序号" width="100" center>
            <template slot-scope="scope">
              <a style="padding-left: 1vw">{{
                (pageNum - 1) * pageSize + scope.$index + 1
              }}</a>
            </template>
          </el-table-column>
          <el-table-column label="设备名称" prop="name"></el-table-column>
          <el-table-column label="抓拍机ID" prop="monitorIp"></el-table-column>
          <el-table-column label="序列号" prop="serialNum"></el-table-column>
          <el-table-column
            label="考勤机SN号"
            prop="atdMachineImei"
          ></el-table-column>
          <el-table-column label="相机名称">
            <template slot-scope="scope">
              <span>{{ scope.row.cameraName || "未绑定" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="抓拍机在线时间"
            prop="updateDate"
          ></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="table-button" @click="edit(scope.row)">编辑</span>
              <span class="table-button-delete" @click="handleDelete(scope.row)"
                >删除</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      :title="addDialogTitle"
      :visible.sync="addDialog"
      width="500px"
      :close-on-click-modal="false"
      :before-close="handleClose"
      center
    >
      <el-form :model="form" label-width="120px" label-position="right">
        <el-form-item label="设备名称：">
          <el-input
            v-model="form.name"
            size="small"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="抓拍机IP：">
          <el-input
            v-model="form.monitorIp"
            size="small"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="序列号：">
          <el-input
            v-model="form.serialNum"
            size="small"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="考勤机Sn号：">
          <el-select
            v-model="form.atdMachineImei"
            size="small"
            placeholder="请选择"
          >
            <el-option
              v-for="item in machineList"
              :label="item.imei"
              :value="item.imei"
              :key="item.imei"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="摄像头">
          <el-select v-model="form.cameraId" size="small" placeholder="请选择">
            <el-option
              v-for="item in cameraList"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose()">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import base from "../../../untils/base";
import myHttp from "../../../untils/port";
import util from "../../../untils/util";
export default {
  data() {
    return {
      projectId: "",
      pageSize: 20,
      pageNum: 1,
      total: 0,

      addDialogTitle: "",
      addDialog: false,

      tableData: [],
      serialNum: "", // 序列号

      form: {
        serialNum: "",
        monitorIp: "",
        name: "",
        atdMachineImei: "",
        cameraId: "",
      },

      machineList: [], // 考勤机列表
      cameraList: [], // 摄像头列表
    };
  },

  created() {
    this.projectId = util.session.get("groupId");
    this.getData();
    this.getList();
    this.getCameraList();
  },

  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },

    handleCurrentChange(val) {
      this.pageNum = val;
      this.getData();
    },

    select() {
      this.pageSize = 20;
      this.pageNum = 1;
      this.getData();
    },

    // 获取考勤机
    getList() {
      myHttp
        .getAttendMachineInfoList({
          projectId: this.projectId,
          inoutType: "6",
        })
        .then((resp) => {
          if (resp.data.code === 200) {
            this.machineList = resp.data.data.attendMachineList;
          } else {
            this.$message.error(resp.data.msg);
            this.dataText = "暂无数据";
          }
        });
    },
    getCameraList() {
      myHttp
        .getCameraListBySomething({
          projectId: this.projectId,
          useType: "5",
        })
        .then((resp) => {
          if (resp.data.code === 200) {
            this.cameraList = resp.data.data.list;
          }
        });
    },
    // 获取数据
    getData() {
      myHttp
        .findSnapMachinePage({
          serialNum: this.serialNum,
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          projectId: this.projectId,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.total = res.data.data.snapMachinePage.total;
            const list = res.data.data.snapMachinePage.list;
            list.forEach((item, index) => {
              item.index = (this.pageNum - 1) * this.pageSize + 1 + index;
            });
            this.tableData = list;
          }
        });
    },

    submit() {
      this.form.projectId = this.projectId;
      if (this.form.id && this.form.id != "") {
        myHttp.updateInfoCapture(this.form).then((res) => {
          if (res.data.code === 200) {
            this.$message.success("修改成功！！");
            this.addDialog = false;
            this.getData();
            this.clearForm();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else {
        myHttp.createInfoCapture(this.form).then((res) => {
          console.log(res);
          if (res.data.code === 200) {
            this.$message.success("添加成功！！");
            this.addDialog = false;
            this.getData();
            this.clearForm();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },

    handleClose() {
      this.addDialog = false;
      if (this.form.id) {
        this.clearForm();
      }
    },

    clearForm() {
      this.form.id = "";
      this.form.serialNum = "";
      this.form.monitorIp = "";
      this.form.name = "";
      this.form.atdMachineImei = "";
      this.form.cameraId = "";
    },

    add() {
      this.addDialogTitle = "绑定设备";
      this.addDialog = true;
    },

    edit(row) {
      this.addDialogTitle = "修改设备";
      this.form.id = row.id;
      this.form.serialNum = row.serialNum;
      this.form.monitorIp = row.monitorIp;
      this.form.name = row.name;
      this.form.cameraId = row.cameraId;
      this.form.atdMachineImei = row.atdMachineImei;
      this.addDialog = true;
    },

    handleDelete(row) {
      this.$confirm("此操作将永久删除该设备, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        myHttp
          .deleteByIdCapture({
            id: row.id,
          })
          .then((res) => {
            if (res.data.code === 200) {
              this.$message.success("删除成功！！");
              this.getData();
            } else {
              this.$message.error(res.data.msg);
            }
          });
      });
    },
  },
};
</script>

<style scoped>
.content {
  height: 100%;
  padding: 1vh 1vw;
}

.content-box {
  height: 100%;
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 2px 2px 6px 0px rgba(77, 110, 177, 0.2);
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  padding: 0 0.8333vw;
  border-bottom: 1px solid #e7e7e7;
}

.table {
  height: calc(100% - 116px);
  padding: 16px 8px;
}

.button {
  display: inline-block;
  width: 80px;
  height: 32px;
  border-radius: 6px;
  background: #fdfefe;
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  line-height: 32px;
  text-align: center;
  font-size: 14px;
  color: #666;
  margin-left: 0.5208vw;
  cursor: pointer;
}

.pagination {
  height: 50px;
  border-radius: 0px 0px 6px 6px;
  background: #ffffff;
  box-shadow: 6px 0px 10px 0px rgba(197, 197, 197, 0.3);
}

.table-button {
  display: inline-block;
  width: 56px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 4px;
  background: rgba(227, 233, 246, 0.05);
  box-sizing: border-box;
  border: 1px solid rgba(142, 163, 206, 0.8);
  font-size: 14px;
  color: #8ea3ce;
  cursor: pointer;
}

.table-button-delete {
  display: inline-block;
  width: 50px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 4px;
  background: rgba(227, 233, 246, 0.05);
  box-sizing: border-box;
  border: 1px solid rgba(236, 15, 15, 0.8);
  font-size: 14px;
  color: #ec0f0f;
  margin-left: 8px;
  cursor: pointer;
}

.content ::v-deep .el-dialog .el-input {
  width: 300px;
}
</style>